"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IERC1822ProxiableUpgradeable__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  inputs: [],
  name: "proxiableUUID",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}];

class IERC1822ProxiableUpgradeable__factory {
  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.IERC1822ProxiableUpgradeable__factory = IERC1822ProxiableUpgradeable__factory;

_defineProperty(IERC1822ProxiableUpgradeable__factory, "abi", _abi);